var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classnames},[(_vm.text)?[_c('div',{class:(_vm.ns + "__text")},[_vm._v(_vm._s(_vm.activeText))])]:_vm._e(),_vm._v(" "),_c('div',{class:(_vm.ns + "__panel")},[_c('button',{class:(_vm.ns + "__button")},[_vm._v(_vm._s(_vm.buttonLabel))])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40f7e160","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/LineClamp.vue
// module id = oLM6
// module chunks = 1